<template>
  <div>
    <vs-sidebar click-not-close parent="#tranksaksi-app" :hidden-background="true" class="full-vs-sidebar tranksaksi-view-sidebar items-no-padding" v-model="isTaxonomyActive" position-right>
      <div class="px-0 pb-6 h-full tranksaksi-area-loading">
        <div class="flex flex-wrap items-center justify-between md:px-8 px-6 py-5 d-theme-dark-bg tranksaksi-header bg-primary">
          <h5 class="text-white">Tambah Taxonomy</h5>
          <feather-icon :icon="$vs.rtl ? 'XIcon' : 'XIcon'" @click="taxonomyAddClose" class="cursor-pointer mr-4" svg-classes="text-white w-6 h-6"></feather-icon>
        </div>
        <component :is="scrollbarTag" class="tranksaksi-scroll-area md:p-8 p-6 mt-base" :settings="settings" :key="$vs.ltr">
          <div class="vx-row">
            <div class="vx-col w-full md:w-1/2">
              <vs-list>
                <vs-list-header color="primary"></vs-list-header>
                <vs-list-item v-for="(taxonomy, index) in listTaxonomy" :key="index" class="flex justify-between" :title="taxonomy.name">
                  <vs-button v-on:click="onMoveRemove(taxonomy.id)" icon-pack="feather" size="small" icon="icon-minus" color="danger"></vs-button>
                </vs-list-item>
              </vs-list>
            </div>
            <div class="vx-col w-full md:w-1/2">
              <vs-list>
                <vs-list-header title="List" color="primary"></vs-list-header>
                <vs-list-item v-for="(akun, index) in listAkun" :key="index" class="flex justify-between" :title="akun.name">
                  <vs-button v-on:click="onMoveAdd(akun.id)" icon-pack="feather" size="small" icon="icon-plus" color="success"></vs-button>
                </vs-list-item>
              </vs-list>
            </div>
          </div>
        </component>
      </div>
    </vs-sidebar>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { mapGetters } from 'vuex'
export default{
  props: {
    isTaxonomyActive: {
      type: Boolean,
      required: true
    },
    taxonomy: {
      type: String,
      required: true
    }
  },
  components: {
    VuePerfectScrollbar
  },
  data () {
    return {
      settings : {
        maxScrollbarLength : 60,
        wheelSpeed         : 0.30
      },
      hapus: false,
      hapusId: null,
      hapusMenu: null,
    }
  },
  watch: {
    isTaxonomyActive (value) {
        if (!value) { return } else {
          this.$vs.loading()
          //this.$store.dispatch('akun/fetchAkunTaxonomy', this.taxonomy)
          setTimeout(() => {
            this.$vs.loading.close()
          }, 3000)
        }
    }
  },
  computed: {
    scrollbarTag () { 
      return this.$store.getters.scrollbarTag
    },
    windowWidth ()  { 
      return this.$store.state.windowWidth                 
    },
    isFormValid () {
      return !this.errors.any() && this.dataAkun
    },
    ...mapGetters({
      user : 'auth/user',
    }),
    listAkun () {
      return this.$store.state.akun.akuns
    },
    listTaxonomy () {
      return this.$store.state.akun.akuntaxonomy
    }
  },
  created () {
  },
  methods: {
    initValues() {
      //if (this.taxonomyData.id) return
      this.dataAkun = 0
      this.changeAkun = false
    },
    changePilihAkun () {
      this.changeAkun = true
    },
    taxonomyAddClose() {
      this.$emit('closeTaxonomy')
    },
    onMoveAdd(id) {
      this.$vs.loading()
      const obj = {
        term_id: id,
        taxonomy: this.taxonomy
      }
      this.$store.dispatch('akun/addAkunTaxonomy', obj)
      .then((response) => {
        this.$vs.loading.close()
        this.$vs.notify({
          title: 'Berhasil',
          color  : 'success',
          text  : response.message,
        })
      })
      .catch(error => {
        this.$vs.loading.close()
        let {data} = error.response
        this.$vs.notify({
          title: 'Error',
          text: data.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      })
    },
    onMoveRemove(id) {
      this.$vs.loading()
      const obj = {
        term_id: id,
        taxonomy: this.taxonomy
      }
      this.$store.dispatch('akun/removeAkunTaxonomy', obj)
      .then((response) => {
        this.$vs.loading.close()
        this.$vs.notify({
          color : 'success',
          text : response.message,
        })
      })
      .catch(error => {
        this.$vs.loading.close()
        let {data} = error.response
        this.$vs.notify({
          title: 'Error',
          text: data.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      })
    },
    submitData () {
      this.$validator.validateAll().then(result => {
        if (result) {
          const obj = {
            term_id: this.dataAkun,
            taxonomy: this.taxonomy
          }
          
          this.$store.dispatch('taxonomy/addTaxonomy', obj)
          this.$emit('closeTaxonomy')
          this.initValues()
        }
      })
    }
  }
}
</script>
